import { render, staticRenderFns } from "./UnpublishModal.vue?vue&type=template&id=591d20ec&"
import script from "./UnpublishModal.vue?vue&type=script&lang=js&"
export * from "./UnpublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports